var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHold(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.599609,
    width: 48,
    height: 48,
    rx: 24,
    fill: "#1F2124"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.8496 16.5V31.5C32.8496 31.8978 32.6916 32.2794 32.4103 32.5607C32.129 32.842 31.7474 33 31.3496 33H27.5996C27.2018 33 26.8203 32.842 26.5389 32.5607C26.2576 32.2794 26.0996 31.8978 26.0996 31.5V16.5C26.0996 16.1022 26.2576 15.7206 26.5389 15.4393C26.8203 15.158 27.2018 15 27.5996 15H31.3496C31.7474 15 32.129 15.158 32.4103 15.4393C32.6916 15.7206 32.8496 16.1022 32.8496 16.5ZM21.5996 15H17.8496C17.4518 15 17.0703 15.158 16.7889 15.4393C16.5076 15.7206 16.3496 16.1022 16.3496 16.5V31.5C16.3496 31.8978 16.5076 32.2794 16.7889 32.5607C17.0703 32.842 17.4518 33 17.8496 33H21.5996C21.9974 33 22.379 32.842 22.6603 32.5607C22.9416 32.2794 23.0996 31.8978 23.0996 31.5V16.5C23.0996 16.1022 22.9416 15.7206 22.6603 15.4393C22.379 15.158 21.9974 15 21.5996 15Z",
    fill: "#FFFFFE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHold);
export default __webpack_public_path__ + "static/media/Hold.f2bf87dc96c7baaa3af4c7d2ee0cfd87.svg";
export { ForwardRef as ReactComponent };